export const environment = {
  production: true,
  appVersion: '1.0.11',
  nameSite: 'NetLinkDeal',
  baseUrl: 'https://netlinkdeal.com/app',
  apiEndPoint: 'https://netlinkdeal.com/app/api/',
  /** Base URL pour les assets TinyMCE (doit correspondre au base-href + /tinymce) */
  tinymceBaseUrl: '/app/tinymce',
  //Support User
  admin: 35,
  //Google favicon
  faviconApi: 'https://encrypted-tbn2.gstatic.com/faviconV2?url=https://',
  //Paypal
  clientId: 'AYqj5ta7a2iJ5jdobnUan0jVwPMhUAzD8XOHbcaXueDeTR9GN4ZoPLggxxJ4qoDRkwWSI5x0ngGSSZQW',
  //Recaptcha
  recaptcha: {
    siteKey: '6Lc_x78iAAAAAGQCFYoH181cv8J2hVIdO3GvK7Nw'
  },
  //CryptoJS
  secret_key: 'w&D<wYmG(]Q|q_/+g!GiT;*iFC(y,Tj!_5d-X#neEFr&s]inK`x;/6pdci:UQA-'
};